<template>
    <div>
        <v-card elevation="0" style="color: black;">
            <v-card-text v-if="!deleteSuccess">
                <v-row align="center">
                    <v-col cols="12">
                        <v-container style="border: 1px solid #145DA0; width: 100%">
                            <v-row align="center" justify="center">
                                <v-col cols="12" :md="hrflag == 'Not authorized' ? 6: 4" style="text-align:center;">
                                    Bookmark&nbsp;
                                    <v-btn class="mr-2" v-if="bookmarked" icon color="#145DA0" @click="unbookmarkApplication" :loading="bookmarkloading">
                                        <v-icon>
                                            mdi-bookmark
                                        </v-icon>
                                    </v-btn>
                                    <v-btn class="mr-2" icon v-else @click="bookmarkApplication" :loading="bookmarkloading">
                                        <v-icon>
                                            mdi-bookmark-outline
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" :md="hrflag == 'Not authorized' ? 6: 4" style="text-align:center;">
                                    ADO Flag&nbsp;
                                    <v-btn class="mr-2" v-if="adoflag" icon color="#FB4570">
                                        <v-icon>
                                            mdi-flag
                                        </v-icon>
                                    </v-btn>
                                    <v-btn class="mr-2" icon v-if="!adoflag">
                                        <v-icon>
                                            mdi-flag-outline
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" md="4" style="text-align:center;" v-if="hrflag != 'Not authorized'">
                                    HR Flag&nbsp;
                                    <v-tooltip bottom v-if="hrflag.value == 1">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mr-2"  icon color="#FB4570" v-bind="attrs" v-on="on">
                                                <v-icon>
                                                    mdi-flag-variant
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ hrflag.comment }}</span>
                                    </v-tooltip>
                                    <v-btn class="mr-2" icon v-if="hrflag.value == 0">
                                        <v-icon>
                                            mdi-flag-variant-outline
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row><br />
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-text>
                        <b>Have you held a CUPE position at King's in the past 36 months?</b>&nbsp;&nbsp;<span class="text-h6"><b>{{ item.cupeposition }}</b></span>
                        <br />
                        <b>Are you legally eligible to work in Canada?</b>&nbsp;&nbsp;<span class="text-h6"><b>{{ item.legaltowork }}</b></span>
                    </v-card-text>
                </v-card><br />
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-title>Course Application&#40;s&#41;</v-card-title>
                    <v-card-text>
                        <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th colspan="11"><b>{{ item.posting.title }} - {{ item.posting.type }} Posting</b></th>
                                    </tr>
                                    <tr>
                                        <th rowspan="2">Term</th>
                                        <th rowspan="2">Section</th>
                                        <th rowspan="2">Class #</th>
                                        <th rowspan="2">Subject</th>
                                        <th rowspan="2">Name</th>
                                        <th rowspan="2">Component</th>
                                        <th colspan="5" style="text-align: center;">Days</th>
                                        <th rowspan="2">Instruction Period</th>
                                    </tr>
                                    <tr>
                                        <th>Mon</th>
                                        <th>Tue</th>
                                        <th>Wed</th>
                                        <th>Thu</th>
                                        <th>Fri</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="course in item.posting.courses" :key="course.classnbr">
                                        <td>{{ item.term }}</td>
                                        <td>{{ course.classsection }}</td>
                                        <td>{{ course.catalognbr }}</td>
                                        <td>{{ course['subject-resolved'] }}</td>
                                        <td>{{ course.descr }}</td>
                                        <td>{{ course.ssrcomponent }}</td>
                                        <td><v-checkbox v-model="course.mon" disabled true-value="Mon"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.tues" disabled true-value="Tue"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.wed" disabled true-value="Wed"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.thurs" disabled true-value="Thu"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.fri" disabled true-value="Fri"></v-checkbox></td>
                                        <td>{{ course.instructionstart }} ~ {{ course.instructionend }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card><br />
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-title>Applicant Information</v-card-title>
                    <v-card-text>
                        <v-expansion-panels v-model="panel" multiple>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <b>General Information</b>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-row dense>
                                                <v-col cols="4">
                                                    <v-text-field label="First Name" outlined v-model="item.generalinfo.firstname" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Last Name" outlined v-model="item.generalinfo.lastname" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Preferred Name" outlined v-model="item.generalinfo.preferredname" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field label="Street Address" outlined v-model="item.generalinfo.address.street" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="City" outlined v-model="item.generalinfo.address.city" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Province" outlined v-model="item.generalinfo.address.province" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Postal Code" outlined v-model="item.generalinfo.address.postalcode" readonly></v-text-field>    
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field label="Home Phone" outlined v-model="item.generalinfo.phone.home" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field label="Cell Phone" outlined v-model="item.generalinfo.phone.cell" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field readonly label="Email Address" outlined v-model="item.generalinfo.email"></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field label="Western Email Address (optional)" outlined v-model="item.generalinfo.westernemail" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-radio-group v-model="item.generalinfo.preferredemail" mandatory row label="Preferred Email Adress" readonly>
                                                        <v-radio
                                                            label="Email Address"
                                                            value="email"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="Western Email Address"
                                                            value="western"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <b>Education History</b>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-row v-for="(count, i) in item.education.length" :key="i" dense>
                                                <v-col cols="12">Entry #{{count}}</v-col>
                                                <v-col cols="12"><v-text-field label="Degree" outlined v-model="item.education[count-1].degree" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="University Attended" outlined v-model="item.education[count-1].university" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Status" outlined v-model="item.education[count-1].status" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Area of Specialization" outlined v-model="item.education[count-1].specialization" readonly></v-text-field></v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <b>Employment History</b>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-row dense>
                                                <v-col cols="6">
                                                    <v-text-field outlined v-model="item.employment.taught" readonly label="Taught at King's"></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field readonly label="Employee Number (if known)" outlined v-model="item.employment.employeenumber"></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-textarea readonly height="70px" label="Course(s) taught at Kings (if applicable)" outlined v-model="item.employment.courses"></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <b>References</b>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-row v-for="(count, i) in 3" :key="i" dense>
                                                <v-col cols="12">Reference {{count}}</v-col>
                                                <v-col cols="12"><v-text-field label="Name" outlined v-model="item.references[count-1].name" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Academic Affiliation" outlined v-model="item.references[count-1].academicaffiliation" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Email Address" outlined v-model="item.references[count-1].email" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Phone" outlined v-model="item.references[count-1].phone" readonly></v-text-field></v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <b>Documents</b>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-simple-table style="width: 100%; border-collapse: collapse;">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th>Type</th>
                                                            <th>File Name</th>
                                                            <th>Download</th>
                                                            <th v-if="permissions.replaceCV"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Resume/CV</td>
                                                            <td>{{ fileCVdownloadname }}</td>
                                                            <td>
                                                                <v-btn color="#145DA0" icon link :href="fileCVdownload"><v-icon>mdi-download</v-icon></v-btn> 
                                                                <span v-if="replacesuccessful">This CV has been replaced. Please close the dialog and re-open to download the most recent CV.</span>
                                                            </td>
                                                            <td v-if="permissions.replaceCV">
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn icon color="#E56997" v-bind="attrs" v-on="on" @click="dialogReplaceCV = true" small><v-icon>mdi-file-replace-outline</v-icon></v-btn>
                                                                    </template>
                                                                    <span>Replace CV</span>
                                                                </v-tooltip>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="item.hasOwnProperty('suppletype1')">
                                                            <td>{{ item.suppletype1 }}</td>
                                                            <td>{{ filesupple1downloadname }}</td>
                                                            <td><v-btn color="#145DA0" icon link :href="filesupple1download"><v-icon>mdi-download</v-icon></v-btn></td>
                                                            <td v-if="permissions.replaceCV"></td>
                                                        </tr>
                                                        <tr v-if="item.hasOwnProperty('suppletype2')">
                                                            <td>{{ item.suppletype2 }}</td>
                                                            <td>{{ filesupple2downloadname }}</td>
                                                            <td><v-btn color="#145DA0" icon link :href="filesupple2download"><v-icon>mdi-download</v-icon></v-btn></td>
                                                            <td v-if="permissions.replaceCV"></td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card-text>
                </v-card><br />
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-title>Admin Use Only</v-card-title>
                    <v-card-subtitle>For <b>{{ item.postingtype }} posting course&#40;s&#41;: {{ item.coursesText }}</b></v-card-subtitle>
                    <v-card-text>
                        <b>Justification Comment&#40;s&#41;</b><br />
                        <v-simple-table style="border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th style="width: 60%">Comments</th>
                                        <th>Made by</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="comment in justificationlist" :key="comment.madeby">
                                        <td style="width: 60%; white-space: pre-wrap;">{{comment.comment}}</td>
                                        <td>{{ comment.madeby }}</td>
                                        <td>{{ comment.madeon }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table><br />
                        <v-row no-gutters v-if="permissions.justifications">
                            <v-col cols="12">
                                <v-textarea label="New Justification Comment" clearable v-model="justification" outlined auto-grow rows="3"></v-textarea>
                            </v-col>
                            <v-col cols="12" style="text-align: right;">
                                <v-btn dark color="#274472" @click="updateJustificationComment" :loading="justificationloading">
                                    <v-icon>mdi-comment-plus</v-icon>&nbsp;Submit
                                </v-btn>
                            </v-col>
                        </v-row> 
                        <b>Seniority Points</b><br />
                        <v-text-field v-model="senioritypoints" :rules="[rules.seniority]" outlined style="width: 500px;" :disabled="!permissions.seniorityPoints">
                            <template v-slot:append-outer>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn dark v-on="on" color="#274472" @click="updateSeniorityPoints" icon :loading="senioritypointloading" large v-if="permissions.seniorityPoints">
                                            <v-icon>mdi-check-circle-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Update seniority points</span>
                                </v-tooltip>
                            </template>
                        </v-text-field><br />
                        <b>Manager Comment&#40;s&#41;</b><br />
                        <v-simple-table style="border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th style="width: 60%">Comments</th>
                                        <th>Made by</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="comment in managerlist" :key="comment.madeby">
                                        <td style="width: 60%; white-space: pre-wrap;">{{comment.comment}}</td>
                                        <td>{{ comment.madeby }}</td>
                                        <td>{{ comment.madeon }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table><br />
                        <v-row no-gutters v-if="permissions.managercomments">
                            <v-col cols="12">
                                <v-textarea label="New Manager Comment" clearable v-model="manager" outlined rows="3" auto-grow></v-textarea>
                            </v-col>
                            <v-col cols="12" style="text-align: right;">
                                <v-btn dark color="#274472" @click="updateManagerComment" :loading="managerloading">
                                    <v-icon>mdi-comment-plus</v-icon>&nbsp;Submit
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-card-text>
            <v-card-text v-else>
                <v-container style="height: 450px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                        >
                            This Application has been deleted.
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions v-if="!deleteSuccess">
                <v-spacer></v-spacer>
                <v-btn color="#FDB750" dark @click="dialogDelete = true" v-if="permissions.deleteapplication">
                    <v-icon>mdi-alert</v-icon>&nbsp;Delete Application
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog
            v-model="dialogReplaceCV"
            width="650"
            persistent
            v-if="permissions.replaceCV"
        >
            <v-card elevation="0">
                <v-toolbar color="#FBE698">
                    <v-toolbar-title>Replace CV file</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogReplaceCV = false">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar><br />
                <v-card-subtitle style="color: #FF8300; text-align: center;"><v-icon color="#FF8300">mdi-alert-outline</v-icon>&nbsp;File attachments should not exceed 10MB in total.</v-card-subtitle>
                <v-card-text>
                    <v-form ref="form">
                        <v-file-input show-size label="Replacement Resume/CV" outlined v-model="replacedCV" id="fileCVreplaced" :rules="[ v => !v || v.size < 10000000 || 'File size should be less than 10MB.']"></v-file-input>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#F51720" @click="replaceCV()" :disabled="replacedCV == null || replacedCV == ''" :loading="replaceloading">Replace</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogDelete"
            width="700"
            persistent
            v-if="permissions.deleteapplication"
        >
            <v-card elevation="0">
                <v-toolbar color="#F51720" dark>
                    <v-toolbar-title>Delete Application</v-toolbar-title>
                </v-toolbar><br />
                <v-card-text>
                    <v-checkbox v-model="finalcheck">
                        <template v-slot:label>
                            <div>
                                The application by <b>{{ item.name }}</b> will be deleted permanently.<br />
                                The action will delete <b>ALL</b> application details, including attachments.<br /><br />
                                I have read and understood that this action is permanent and it cannot be reverted.
                            </div>
                        </template>
                    </v-checkbox>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#15B5B0" @click="dialogDelete = false">Cancel</v-btn>
                    <v-btn text color="#F51720" @click="deleteApplication" :disabled="!finalcheck" :loading="deleteloading">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import auth from '@/js/auth';
export default {
    props: {
        item: {
            required: true
        }
    },
    data(){
        return {
            permissions: {},
            host: location.hostname.toString(),
            bookmarkloading: false,
            bookmarked: false,
            adoflag: false,
            hrflag: false,
            adoloading: false,
            dialogReplaceCV: false,
            dialogDelete: false,
            deleteloading: false,
            fileCVdownload: "",
            filesupple1download: "",
            filesupple2download: "",
            fileCVdownloadname:"",
            filesupple1downloadname: "",
            filesupple2downloadname: "",
            panel: [0, 1, 2, 3, 4],
            replacedCV: null,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            finalcheck: false,
            justification: "",
            justificationlist: [],
            justificationloading: false,
            managerloading: false,
            senioritypoints: "",
            senioritypointloading: false,
            manager: "",
            managerlist: [],
            rules: {
                seniority: v=> /^\d+([\.]?\d+)*$/.test(v) || "Numbers only",
            },
            deleteSuccess: false,
            replaceloading: false,
            replacesuccessful: false
        }
    },
    methods: {
        getPermissions(){
            const that = this;
            let permission = auth.get_permissions();

            if(permission.hasOwnProperty("justifications")){
                if(permission.justifications == 1){
                    that.permissions["justifications"] = true;
                }else {
                    that.permissions["justifications"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["justifications"] = true;
            }else {
                that.permissions["justifications"] = false;
            }

            if(permission.hasOwnProperty("managercomments")){
                if(permission.managercomments == 1){
                    that.permissions["managercomments"] = true;
                }else {
                    that.permissions["managercomments"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["managercomments"] = true;
            }else {
                that.permissions["managercomments"] = false;
            }

            /* 2024 Update - setting ADO flag is moved to "Accounts" section
            if(permission.hasOwnProperty("setADOflag")){
                if(permission.setADOflag == 1){
                    that.permissions["setADOflag"] = true;
                }else {
                    that.permissions["setADOflag"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["setADOflag"] = true;
            }else {
                that.permissions["setADOflag"] = false;
            }
            */

            if(permission.hasOwnProperty("seniorityPoints")){
                if(permission.seniorityPoints == 1){
                    that.permissions["seniorityPoints"] = true;
                }else {
                    that.permissions["seniorityPoints"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["seniorityPoints"] = true;
            }else {
                that.permissions["seniorityPoints"] = false;
            }

            if(permission.hasOwnProperty("replaceCV")){
                if(permission.replaceCV == 1){
                    that.permissions["replaceCV"] = true;
                }else {
                    that.permissions["replaceCV"] = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.permissions["replaceCV"] = true;
            }else {
                that.permissions["replaceCV"] = false;
            }

            if(auth.is_ITS()){
                that.permissions["deleteapplication"] = true;
            }else {
                that.permissions["deleteapplication"] = false;
            }
        },
        initializeValue(){
            const that = this;
            
            if(that.item.adoFlag == 1){
                that.adoflag = true;
            }else {
                that.adoflag = false;
            }

            if(that.item.hasOwnProperty("hrFlag")){
                that.hrflag = that.item.hrFlag
            }else {
                that.hrflag = 'Not authorized'
            }
            
            that.justificationlist = that.item.justifications;
            that.managerlist = that.item.managercomments;
            that.senioritypoints = that.item.seniorityPoints;

        },
        getApplicationData(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getapplications&data={"id":"'+that.item.applicationid+'"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(that.item.inbookmark == true){
                            that.bookmarked = true;
                        }else {
                            that.bookmarked = false;
                        }

                        if(json.data[0].hasOwnProperty("fileCV_download")){
                            that.fileCVdownload = json.data[0]["fileCV_download"];
                            that.fileCVdownloadname = json.data[0]["fileCV_download_filename"];
                        }

                        if(json.data[0].hasOwnProperty("filesupple1_download")){
                            that.filesupple1download = json.data[0]["filesupple1_download"];
                            that.filesupple1downloadname = json.data[0]["filesupple1_download_filename"];
                        }

                        if(json.data[0].hasOwnProperty("filesupple2_download")){
                            that.filesupple2download = json.data[0]["filesupple2_download"];
                            that.filesupple2downloadname = json.data[0]["filesupple2_download_filename"];
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        bookmarkApplication(){
            const that = this;
            that.bookmarkloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=setBookmark&data={"applicationid": "'+that.item.applicationid+'", "postingid": "'+that.item.postingid+'"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.bookmarked = true;
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }
                    that.bookmarkloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.bookmarkloading = false;
                })
        },
        unbookmarkApplication(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=deleteBookmark&data={"id": "'+that.item.bookmarkid+'"}';
            that.bookmarkloading = true;
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.setSnackbar("Successfully removed from the bookmark", "#81B622"); //green
                        that.bookmarked = false;
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }
                    that.bookmarkloading = false;
                })
                .catch(function () {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.bookmarkloading = false;
                })
        },
        deleteApplication(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=deleteApplication&data={"applicationid": "'+that.item.applicationid+'"}';
            that.deleteloading = true;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.setSnackbar("Successfully Deleted Application", "#81B622"); //green
                        that.dialogDelete = false;
                        that.deleteSuccess = true;
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }
                    that.deleteloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.deleteloading = false;
                })
        },
        /* 2024 Update - ADO flagging is moved to "Accounts" section */
        // setADOFlag(){
        //     const that = this;
        //     that.adoloading = true;
        //     let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
        //     let flag = {
        //         type: "setADOflag",
        //         value : 1,
        //         id : that.item.applicationid
        //     };

        //     const formData = new FormData();

        //     formData.append("mode", "setAdminData");
        //     formData.append("data", JSON.stringify(flag));

        //     //API calling
        //     fetch(api,{
        //             method: "POST",
        //             body: formData
        //         })
        //         .then(function (response) {
        //             return response.json();
        //         })
        //         .then(function (resultData) {
        //             if(!resultData.result.match(/^OK/i)){
        //                 that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
        //             }else {
        //                 that.setSnackbar("ADO Flag set for this application", "#388E3C"); //green
        //                 that.adoflag = true;
        //             }

        //             that.adoloading = false;

        //         })
        //         .catch(function(err){
        //             that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
        //             that.adoloading = false;
        //         })
        //     //End of API calling
        // },
        updateJustificationComment(){
            const that = this;
            that.justificationloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
            let comment = {
                type: "justification",
                course : that.item.coursesText,
                comment: that.justification,
                id : that.item.applicationid
            };

            const formData = new FormData();

            formData.append("mode", "setAdminData");
            formData.append("data", JSON.stringify(comment));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Justification updated for this application", "#388E3C"); //green
                        that.justificationlist.push({
                            "comment": that.justification,
                            "madeby": auth.get_user()["commonname"],
                            "madeon": "just now"
                        });

                        that.justification = "";
                    }
                    that.justificationloading = false;

                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.justificationloading = false;
                })
            //End of API calling
        },
        updateManagerComment(){
            const that = this;
            that.managerloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
            let comment = {
                type: "managerComment",
                course : that.item.coursesText,
                comment: that.manager,
                id : that.item.applicationid
            };

            const formData = new FormData();

            formData.append("mode", "setAdminData");
            formData.append("data", JSON.stringify(comment));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Manager Comment made for this application", "#388E3C"); //green
                        that.managerlist.push({
                            "comment": that.manager,
                            "madeby": auth.get_user()["commonname"],
                            "madeon": "just now"
                        });

                        that.manager = "";
                    }

                    that.managerloading = false;

                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.managerloading = false;
                })
            //End of API calling
        },
        updateSeniorityPoints(){
            const that = this;
            that.senioritypointloading = true;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
            let points = {
                type: "seniorityPoints",
                value: that.senioritypoints,
                id : that.item.applicationid
            };

            const formData = new FormData();

            formData.append("mode", "setAdminData");
            formData.append("data", JSON.stringify(points));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Seniority Points updated for this application", "#388E3C"); //green
                    }

                    that.senioritypointloading = false;

                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.senioritypointloading = false;
                })
            //End of API calling

        },
        replaceCV(){
            const that = this;
            if(that.$refs.form.validate()){
                that.replaceloading = true;
                let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

                const formData = new FormData();

                formData.append("mode", "replaceCV");
                formData.append("uid", that.item.uid);
                formData.append("fileCV", that.replacedCV);

                //API calling
                fetch(api,{
                        method: "POST",
                        body: formData
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (resultData) {
                        if(!resultData.result.match(/^OK/i)){
                            that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                            that.replaceloading = false;
                        }else {
                            that.setSnackbar("Success: "+resultData.message, "green"); //orange
                            that.replaceloading = false;
                            that.replacesuccessful = true;
                            that.dialogReplaceCV = false;
                            that.replacedCV = null;
                        }
                    })
                    .catch(function(err){
                        that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                        that.replaceloading = false;
                    })
                //End of API calling
            }
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getPermissions();
        that.deleteSuccess = false;
        that.getApplicationData();
        that.initializeValue();
    }
}
</script>